const returnEmptyStringWhenNull = item => {
  if (item) {
    return item;
  } else {
    return '';
  }
};

export default returnEmptyStringWhenNull;
